import { chakra } from '@stockx/ui';
import Slider from 'react-slick';

export const StyledUserGeneratedContentCarousel = chakra(Slider, {
  baseStyle: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignitems: 'center',
    justifyContent: 'center',

    'button.slick-arrow.slick-prev': {
      display: 'none !important',
    },
    'button.slick-arrow.slick-next': {
      display: 'none !important',
    },

    '.slick-list': {
      position: 'relative',
      margin: 0,
      maxHeight: 'inherit',
      overflow: 'hidden',
      padding: 0,
      overflowX: { base: 'scroll', xl: 'hidden' },

      '.slick-track': {
        display: 'flex !important',
        gap: '6px',
      },

      msTouchAction: { base: 'auto', xl: 'none' },
      touchAction: { base: 'auto', xl: 'none' },
    },

    '.slick-slide': {
      width: '100% !important',
    },
  },
});
